
import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';

export const dynamicBaseQuery = async (args, WebApi, extraOptions) => {
    
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: window.REACT_APP_BASE_URL,
    setCredentials: "include", //cookies
    prepareHeaders: async (headers, { getState }) => {
      headers.set("Content-Type", "application/json");
      const token = await localStorage.getItem("token");
      if (token && token?.length > 0) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  });
  return rawBaseQuery(args, WebApi, extraOptions);
};

const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await dynamicBaseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    // try to get a new token
  } else if (result.error && result.error.status === 400) {
    // try to get a new token
    // global.toast.show(result.error.data?.message || 'Something went wrong.', { type: 'danger' });
    // show toast here
  }
  return result;
};

export const backendApi = createApi({
  reducerPath: "backendApi",
  overrideExisting: true,
  baseQuery: baseQueryWithReauth,
  // refetchOnMountOrArgChange: 30,
  tagTypes: [],
  endpoints: () => ({}),
});
